import { get } from 'lodash'

import * as actions from '../actions/Media'

const getInitialState = () => ({
    data: {},

    videos: [],
    images: [],
    posts: [],
    title: null,
    isError: false,
    isErrorNotFound: false,
    isFetched: false,
    isFetching: false,
    slug: null,
})

/* eslint-disable complexity */
export const media = (state = getInitialState(), action) => {
    const payload = get(action, 'payload')
    switch (action.type) {
        case actions.START_FETCHING_MEDIA:
            return {
                ...state,
                isError: false,
                isErrorNotFound: false,
                isFetching: true,
                isFetched: false,
            }
        case actions.STOP_FETCHING_MEDIA:
            return {
                ...state,
                isFetching: false,
                isFetched: true,
            }
        case actions.SET_ERROR_FETCHING_MEDIA:
            return {
                ...state,
                isError: true,
                isErrorNotFound: get(action.payload, 'errorData.status') === 404,
            }

        case actions.UPDATE_MEDIA:
            return {
                ...state,
                //data: action.payload.data,
                videos: payload.videos,
                images: payload.images,
                posts: payload.posts,
                title: payload.title,
                slug: payload.slug,
                isError: false,
                isErrorNotFound: false,
            }
        case actions.UPDATE_MEDIA_NULL:
            return {
                ...state,
                title: payload.title,
                slug: payload.slug,
                isError: false,
                isErrorNotFound: payload.errorNotFound,
            }
        case actions.UPDATE_MEDIA_PAGE:
            return {
                ...state,
                data: payload.data,
                title: payload.title,

                slug: payload.slug,
                isError: false,
                isErrorNotFound: false,
            }
        default:
            return state
    }
}
